<template>
  <div class="businessServiceList">
    <div class="searchwrap">
      <div class="inputwrap">
        <input
          id="searchinput"
          @keypress="enterPress"
          class="searchinput"
          type="text"
          name=""
          v-model="searchText"
          placeholder="客户/地区"
          @blur="inputBlur"
          @focus="inputFocus"
        >
        <i
          @click="onSearchClick"
          class="inputstart-icon iconfont icon-search"
          :class="(inputIsFocus && !searchText) || (inputIsFocus || searchText) ? 'lf5' : 'lf90'  "
        ></i>
        <i
          class="inputend-icon iconfont"
          :class="searchText ? 'icon-clear' : ''"
          @click="clearInput"
        ></i>
      </div>
    </div>
    <div class="filterBtn" @click="showFilter">
      筛选
      <i class="iconfont icon-select"></i>
    </div>
    <div
      class="filterText"
    >{{filterText == "全部,全部,全部" ? "全部" : filterText.replace("全部,",'').replace("全部,",'').replace(",全部",'')}} ({{totalCount}})</div>
    <div v-if="isEmpty" class="empty">
      <img src="../../../assets/images/bnodata.png" alt="">
      <div class="desc">暂无数据</div>
    </div>
    <div v-else class="list">
      <van-list
        :immediate-check="false"
        :offset="50"
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="onLoad"
      >
        <van-row
          @click.native="linkSkip('businessServiceDetail',{service:item},'','')"
          class="listCard"
          v-for="item in data"
          :key="item.acctOrderServiceId"
        >
          <van-col span="20">
            <div class="topTitleRow">
              {{item.serviceName + (item.itemName ? (':' + item.itemName) : '')}}
            </div>
            <div class="subText">{{item.customerName}}</div>
            <div class="subText">{{item.province ? item.province : ''}}{{item.city ? item.city : ''}}{{item.district ? item.district : ''}}</div>
          </van-col>
           <van-col span="4" class="middle-height">
            <div :class="item.surplusDays<0 ? 'red date-number' : 'date-number'" v-show="item.status != 3 && item.currentNode != 1000">{{item.surplusDays > 0 ? (item.surplusDays + '天') : (Math.abs(item.surplusDays) + '天')}}</div>
            <div class="status-text subText" v-show="item.status != 3">{{item.currentNode == 1000 ? '已完成' : (item.surplusDays >= 0 ? '剩余' : '超期')}}</div>
            <div class="status-text subText" v-show="item.status == 3">未开始</div>
          </van-col>
        </van-row>
      </van-list>
    </div>
    <van-loading class="loadingIcon" v-show="loading" type="spinner" color="#1fadf6">加载中...</van-loading>
    <filterComponent
      :options="toptions"
      @chooseComplete="chooseComplete"
      @resetOptions="resetOptions"
      @handleSelectOption="handleSelectOption"
      @filterShowFalse="onFilterCancel"
      :showFilter="showfilter"
    ></filterComponent>
  </div>
</template>

<script>
import Vue from "vue";
import filterComponent from "@/components/Filter.vue";
import config from "@/common/config";

import {
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Toast,
  List,
  Search,
  Loading
} from "vant";
Vue.use(DropdownMenu)
  .use(DropdownItem)
  .use(Row)
  .use(Col)
  .use(List)
  .use(Search)
  .use(Loading);
export default {
  name: "businessServiceList",
  components: {
    filterComponent
  },
  data() {
    return {
      showfilter: false,
      toptions: config.func.clone(
        config.pageConfig.businessFilterOptions
      ),
      originOptions: config.func.clone(
        config.pageConfig.businessFilterOptions
      ),
      filterParams: {
        customerStatus: 0,
        serviceId: -1,
        staffId: 0
      },
      page: 1,
      data: [],
      loading: false,
      finished: false,
      searchText: "",
      filterText: "全部",
      inputIsFocus: false,
      totalCount:'',
      isEmpty:false,
      powerData: this.$store.state.powerData || [],
    };
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    window.sessionStorage.setItem('_businessFilterOptions', JSON.stringify(this.toptions))
    if (to.path.indexOf('/businessServiceDetail') < 0) {
      window.sessionStorage.removeItem('_businessFilterOptions')
    }
    next()
  },
  methods: {
    //判断职员权限
    estimatePower (menuName,tabName,operateName) {
      for(let i=0,lenI=this.powerData.length;i<lenI;i++){
        //  判断菜单名
        if(menuName==this.powerData[i].name){
          for(let j=0,lenJ=this.powerData[i].children.length;j<lenJ;j++){
            //  判断页签名
            if(tabName==this.powerData[i].children[j].name){
              if(!operateName){
                return this.powerData[i].children[j].status;
              }else{
                for(let k=0,lenK=this.powerData[i].children[j].children.length;k<lenK;k++){
                  //  判断
                  if(operateName==this.powerData[i].children[j].children[k].name){
                    return this.powerData[i].children[j].children[k].checked;
                  }
                }
              }
            }
          }
        }
      }
    },
    linkSkip(name, params, redType, rid) {
      if(name == 'businessServiceDetail'){
        if(!this.estimatePower("工商服务","服务管理")){
          Toast("没有权限：工商服务-服务管理-显示菜单");
          return;
        }
      }
      if (rid) {
        this.$root.$emit("log-record", rid);
      }
      this.$store.dispatch("setBusinessServiceInfo", params.service);

      this.$router.push({
        name: name,
        query: params
      });
    },
    //获取工商服务类型
    getBussTypeList() {
      this.$http
        .get("/fc/small/program/service/item")
        .then(res => {
          if (res.data.code == 200) {
            let busrdata = res.data.data;
            if(busrdata && busrdata.length>0){
              let tlist = busrdata.map(p=>{
                if(p.serviceId == 5){
                  return { text: p.serviceName, value: p.serviceId, selected: false, show: false }
                }else{
                  return { text: p.serviceName, value: p.serviceId, selected: false, show: true }
                }
              })
              let newOptions = config.func.clone(config.pageConfig.businessFilterOptions)
              newOptions[2].children = [...newOptions[2].children,...tlist]
              this.toptions = newOptions
            }
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
            Toast(error);
        });
    },
    getBusinessList() {
      this.loading = true;
      let url =
        "/fc/small/program/servicenew/list?page=" +
        this.page +
        "&limit=10";
      let params = config.func.clone(this.filterParams);
      if (this.searchText.trim() != "") {
        params.serach = this.searchText;
      }
      this.$http
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = [...this.data, ...res.data.data.items];
            if(this.data.length == 0){
              this.isEmpty = true
            }else{
              this.isEmpty = false
            }
            this.totalCount = res.data.data.totalCount;
          } else {
            Toast(res.data.msg);
            this.finished = true;
          }
          // 加载状态结束
          this.loading = false;
          if (res.data.data.items.length < 10) {
            this.finished = true;
          }
        })
        .catch(error => {
          console.log(error, "error");
          // 加载状态结束
          this.loading = false;
          this.finished = true;
        });
    },
    showFilter() {
      this.showfilter = !this.showfilter;
    },
    onFilterCancel() {
      this.showfilter = false;
    },
    handleSelectOption(ivalue, ovalue) {
      const newOptions = config.func.clone(this.toptions);
      newOptions.forEach(p => {
        if (p.value == ivalue) {
          p.children.forEach(o => {
            if (o.value == ovalue) {
              o.selected = true;
            } else {
              o.selected = false;
            }
          });
        }
      });

      this.toptions = newOptions;
    },
    //点击选好了
    chooseComplete() {
      this.filterText = "";
      //遍历this.toptions对象获取selected为true的选项即为选择项
      this.toptions.forEach(p => {
        if (p.value == 1) {
          p.children.forEach(o => {
            if (o.selected == true) {
              this.filterParams.customerStatus = o.value;
              this.filterText += o.text + ",";
            }
          });
        }
        if (p.value == 2) {
          p.children.forEach(o => {
            if (o.selected == true) {
              this.filterParams.staffId = o.value;
              this.filterText += o.text + ",";
            }
          });
        }
        if (p.value == 3) {
          p.children.forEach(o => {
            if (o.selected == true) {
              this.filterParams.serviceId = o.value;
              this.filterText += o.text;
            }
          });
        }
      });
      this.page = 1;
      this.data = [];
      this.finished = false;
      this.getBusinessList();
      this.showfilter = false;
    },
    resetOptions() {
      this.toptions = config.func.clone(this.originOptions);
      this.filterParams = {
        customerStatus: 0,
        serviceId: -1,
        staffId: 0
      };
      this.searchText = "";
      this.filterText = "全部";
      this.showfilter = false;
      this.page = 1;
      this.data = [];
      this.finished = false;
      this.getBusinessList();
    },
    onLoad() {
      this.page++;
      this.finished = false;
      this.getBusinessList();
    },
    onSearch() {
      this.page = 1;
      this.data = [];
      this.finished = false;
      this.getBusinessList();
      this.showfilter = false;
    },
    onSearchClick() {
      if (!this.inputIsFocus && this.searchText == "") {
        return false;
      }
      this.page = 1;
      this.data = [];
      this.finished = false;
      this.getBusinessList();
      this.showfilter = false;
    },
    inputFocus() {
      this.inputIsFocus = true;
    },
    inputBlur() {
      this.inputIsFocus = false;
    },
    clearInput() {
      this.searchText = "";
      this.onSearch();
    },
    enterPress(event) {
      if (event.keyCode == 13) {
        this.onSearch();
      }
    }
  },
  mounted: function() {
    if (window.sessionStorage.getItem('_businessFilterOptions')) {
      this.toptions = []
      this.toptions = JSON.parse(window.sessionStorage.getItem('_businessFilterOptions'))
      this.chooseComplete()
    } else {
      this.getBussTypeList();
      this.getBusinessList();
    }
    //滚动条置顶
    document.documentElement.scrollTop = document.body.scrollTop = 0;
  }
};
</script>

<style type="text/css" lang="stylus" scoped>
.businessServiceList {
  height: 100%;
  overflow: hidden;
  .filterBtn {
    background: #F9FBFC;
    color: #8896A4;
    width: 0.54rem;
    height: 0.3rem;
    line-height: 0.3rem;
    border: 1px solid #DAE5F1;
    border-radius: 100px;
    position: absolute;
    top: 0.12rem;
    right: 0.12rem;
    padding: 0 0.1rem;
  }
  .list {
    height: calc(100% - 0.84rem);
    overflow-y: auto;
    .van-list{
      padding-bottom: 0.12rem;
    }
  }
  .icon-select {
    font-size: 0.12rem;
    margin-left: 0.04rem;
  }

  .filterText {
    padding: 0.12rem;
  }

  .searchwrap {
    padding: 0.12rem 0.14rem;
    width: 100%;
    line-height: 0.32rem;
    box-sizing: border-box;
    background: #ffffff;
    padding-right: 0.94rem;

    .inputwrap {
      position: relative;
    }

    .searchinput {
      width: 100%;
      padding: 0.08rem 0.25rem;
      height: 0.32rem;
      text-align: center;
      box-sizing: border-box;
      border-radius: 18px;
      border: 0;
      outline: none ;
      border: 1px solid #E6EBF0;
      -webkit-appearance: none;
    }

    i {
      position: absolute;
      width: 30px;
      top: 0;
      line-height: 0.32rem;
      text-align: center;
      color: #bfcbd9;
      transition: all 0.3s;
    }

    .inputend-icon {
      right: 0px;
      font-size: 0.14rem;
    }

    .inputstart-icon {
      font-size: 0.14rem;
    }

    .lf90 {
      left: 0.8rem;
    }

    .lf5 {
      left: 0.01rem;
    }
  }

  .van-list {
    padding: 0 0.12rem;

    .listCard {
      padding: 0.17rem 0.12rem;
      background-color: #ffffff;
      border-radius: 6px;
      margin-bottom: 0.12rem;
      height 0.56rem
      .topTitleRow{
        overflow hidden
        font-size 0.15rem
        font-weight bold
      }
      .taskType {
        font-size: 0.16rem;
        float left
        max-width: 1.4rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .statusText{
         float left
         margin-left 0.06rem
         display inline-block
         border-radius 2px
         padding 0 0.02rem
         font-size 0.1rem
         position relative
         top 0.02rem
      }
      .done{
        border 1px solid #A5B0BA;
        color #A5B0BA
        background-color #F9FBFC
      }
      .active{
        border 1px solid #00B3FF;
        color #00B3FF
        background-color #E7F8FF
      }
      .limitDate {
        float: right;
        color: #516374;
      }

      .subText {
        color: #A8B0B9;
        font-size: 0.12rem;
        padding: 0.01rem 0;
      }
    }
  }

  .empty {
    text-align: center;
    margin-top: 1.4rem;

    img {
      width: 0.8rem;
    }

    .desc {
      margin-top: 0.08rem;
      color: #B4BEC7;
      font-size: 0.12rem;
    }
  }

  .loadingIcon {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .van-loading__text {
      color: #1fadf6;
    }
  }

  .sImg {
    width: 0.5rem;
    height: 0.5rem;
    position: relative;
    top: 0.03rem;
  }
  .date-number{
    font-weight bold
    font-size 0.17rem
  }
  .red{
    color #FF4846
  }
  .middle-height{
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 0.56rem;
    text-align: right;
  }
}
</style>